<template>
  <div
    class="article-gallery"
    @click="openGallery">
    <CloudImage
      fluid
      :width="800"
      :height="400"
      :src="poster" />
    <div
      class="bottom-left">
      <slot />
    </div>
    <div
      class="gallery-photos"
      v-if="images.length">
      {{ images.length }}
      <FlatIcon
        name="camera-white"
        :size="16" />
      <f7-photo-browser
        ref="photoBrowser"
        :photos="images"
        theme="dark"
        :popupCloseLinkText="close" />
    </div>
  </div>
</template>

<script>
import CloudImage from '@/components/io/CloudImage'
export default {
  name: 'ArticleGallery',
  components: {
    CloudImage
  },
  props: {
    poster: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      close: this.t('close')
    }
  },
  methods: {
    openGallery () {
      this.$refs.photoBrowser.open()
    }
  }
}
</script>

<style lang="scss">
.article-gallery {
  display: block;
  position: relative;
  background-position: center;
  background-size: cover;
  &:before {
    content: '';
    display: block;
    padding-bottom: 50%;
  }
  .bottom-left {
    position: absolute;
    bottom: 16px;
    left: 16px;
  }
  .gallery-photos {
    position: absolute;
    bottom: 16px;
    right: 16px;
    color: white;
    font-weight: bold;
    background: rgba(black, .7);
    line-height: 40px;
    padding: 0 10px 0 12px;
    border-radius: 20px;
    cursor: pointer;
    span {
      display: inline-block;
      vertical-align: text-bottom;
      padding: 0 3px;
      margin-left: 4px;
    }
  }
  .cloud-image {
    position: absolute;
    top: 0;
    bottom: 0;
  }
}
</style>
